const common = {
  version: 'v1',
  locale: 'it',
}

const production = {
  baseURL: 'https://api.basicbm.com/api',
  baseDomain: 'https://www.basicbm.com/',
  templatesURL: 'https://api.basicbm.com/templates',
}

const local = {
  baseURL: 'https://api.basicbm.com/api',
  baseDomain: 'https://www.basicbm.com/',
  templatesURL: 'https://api.basicbm.com/templates',
  locale: 'it',
}

export const environment = Object.assign(common, process.env.NODE_ENV === 'development' ? local : production)
